export default __webpack_public_path__ + "static/media/IMG_9891.80e2eb12.jpg";